import { useEffect, useState } from 'react';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../firebase-config';
import { BlogPost } from '../types/blog-admin';
import { generateSitemap } from '../utils/sitemap';
import { Loader2 } from 'lucide-react';

export default function SitemapPage() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAndGenerateSitemap = async () => {
      try {
        // Fetch published posts
        const q = query(
          collection(db, 'blogPosts'),
          where('status', '==', 'published'),
          orderBy('publishedAt', 'desc')
        );
        const snapshot = await getDocs(q);
        const posts = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })) as BlogPost[];

        // Generate sitemap
        const baseUrl = window.location.origin;
        const sitemapXml = generateSitemap(posts, baseUrl);

        // Set content type and render XML
        document.body.innerHTML = `<pre>${sitemapXml.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</pre>`;

        // Create a downloadable version
        const blob = new Blob([sitemapXml], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'sitemap.xml';
        document.body.appendChild(link);

        setLoading(false);
      } catch (error) {
        console.error('Error generating sitemap:', error);
        document.body.innerHTML = '<h1>Error generating sitemap</h1>';
        setLoading(false);
      }
    };

    fetchAndGenerateSitemap();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="ml-3 text-muted-foreground">Generating sitemap...</span>
      </div>
    );
  }

  return null;
}
